import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { QA_NAME_CONFIRMATION } from '../../../../../constants/qa'
import { ConfirmationModal } from '../../../../Confirmation'
import { useRequestProfileTabEmailsItemActions } from '../useRequestProfileTabEmailsItemActions'
import { useRequestProfileTabEmailsMassActions } from '../useRequestProfileTabEmailsMassActions'

export function useRequestProfileTabEmailsActions({
  exclude,
  filterValues,
  requestId,
  selectAllPages,
  selected,
  onCleanSelection,
  onCloseModal,
  onReload,
  onSetModal,
}) {
  const { t } = useTranslation()

  const [isPerformingAction, setPerformingAction] = useState(false)

  function showConfirmModal({ description, submitText, onSubmit }) {
    onSetModal(
      <ConfirmationModal
        actionButtonsProps={{ submitText }}
        description={description}
        qaName={QA_NAME_CONFIRMATION}
        onCancel={onCloseModal}
        onSubmit={onSubmit}
      />
    )
  }

  function showDeleteConfirmModal({ onSubmit }) {
    showConfirmModal({
      description: t('RequestProfile.TabEmailsDeleteConfirmationKey'),
      submitText: t('Modal.DeleteBtnKey'),
      onSubmit,
    })
  }

  const { setImportant, setItemAction } = useRequestProfileTabEmailsItemActions(
    {
      requestId,
      setPerformingAction,
      showDeleteConfirmModal,
      onCloseModal,
      onReload,
      onSetModal,
    }
  )

  const { setMassAction } = useRequestProfileTabEmailsMassActions({
    exclude,
    filterValues,
    requestId,
    selectAllPages,
    selected,
    setPerformingAction,
    showDeleteConfirmModal,
    onCleanSelection,
    onCloseModal,
    onReload,
  })

  return {
    isPerformingAction,
    setImportant,
    setItemAction,
    setMassAction,
  }
}
